import { createBrowserRouter } from 'react-router-dom';

// Route path constants
import ProtectedRoute from './ProtectedRoute';
import Layout from '../components/Layout';
import Contracts from '../pages/Contracts/Contracts';
import Invoices from '../pages/Invoices/Invoices';
import LoginLayout from '../components/Login/LoginLayout';
import Summary from '../pages/Summary/Summary';
import { AuthProvider } from '../providers/AuthProvider';
import InactiveUser from '../components/InactiveUser/InactiveUser';
import LoginPage from '../components/Login/LoginPage';
import AddUser from '../pages/UserManagement/UserManagementForms/AddUser.tsx';
import ConfirmUser from '../pages/UserManagement/ConfirmUser/ConfirmUser.tsx';
import UserManagement from '../pages/UserManagement/UserManagement.tsx';
import EditUser from '../pages/UserManagement/UserManagementForms/EditUser.tsx';
import EnrollmentLayout from '../components/Enrollment/EnrollmentLayout.tsx';
import DisclosureStart from '../pages/Enrollment/DisclosureStart/DisclosureStart.tsx';
import DisclosureAcknowledgement from '../pages/Enrollment/DisclosureAcknowledgement/DisclosureAcknowledgement.tsx';
import DisclosureAcceptanceSuccess from '../pages/Enrollment/DisclosureAcceptanceSuccess/DisclosureAcceptanceSuccess.tsx';
import ForgotPassword from '../pages/ForgotPassword/ForgotPassword.tsx';
import EnrollmentStart from '../pages/Enrollment/EnrollmentStart/EnrollmentStart.tsx';
import ExpiredPage from '../pages/Enrollment/EnrollmentStart/ExpiredLink/ExpiredLink.tsx';
import VerifyOtp from '../pages/Enrollment/VerifyOtp/VerifyOtp.tsx';
import Lockout from '../pages/Enrollment/VerifyOtp/Lockout.tsx';
import EnrollmentError from '../components/Enrollment/EnrollmentError.tsx';
import CreatePassword from '../pages/CreatePassword/CreatePassword.tsx';
import RootErrorBoundary from '../components/Error/RootErrorBoundary.tsx';

export const ROUTE_LOGIN = '/login';
export const ROUTE_INACTIVE = 'inactive';
export const ROUTE_ROOT = '/';
export const ROUTE_CONTRACTS = 'contracts';
export const ROUTE_INVOICES = 'invoices';
export const ROUTE_ADD_USER = 'add-user';
export const ROUTE_EDIT_USER = 'edit-user';
export const ROUTE_CONFIRM_USER = 'confirm-user';
export const ROUTE_USER_MANAGEMENT = '/user-management';
export const USER_MANAGEMENT_URI = 'user-management';
export const ROUTE_EMPTY = '';
export const ROUTE_ERROR = 'error';

export const ROUTE_ENROLLMENT = '/enrollment';
export const ROUTE_ENROLLMENT_START = 'start';
export const ROUTE_EXPIRED_LINK = 'expired-link';
export const ROUTE_VERIFY_OTP = 'verify-otp';
export const ROUTE_OTP_LOCKOUT = 'lockout';
export const ROUTE_CREATE_PASSWORD = 'create-password';
export const ROUTE_DISCLOSURE_START = 'disclosure';
export const ROUTE_DISCLOSURE_ACKNOWLEDGEMENT = 'disclosure-acknowledgement';
export const ROUTE_DISCLOSURE_ACCEPTANCE_SUCCESS = 'success';
export const ROUTE_FORGOT_PASSWORD = '/forgot-password';

export const router = createBrowserRouter([
	{
		path: ROUTE_LOGIN,
		element: <LoginLayout />,
		children: [
			{
				path: '',
				element: <LoginPage />,
			},
			{
				path: ROUTE_INACTIVE,
				element: <InactiveUser />,
			},
		],
	},
	{
		path: ROUTE_ENROLLMENT,
		element: <EnrollmentLayout />,
		children: [
			{
				path: ROUTE_ENROLLMENT_START,
				element: <EnrollmentStart />,
			},
			{
				path: ROUTE_EXPIRED_LINK,
				element: <ExpiredPage />,
			},
			{
				path: ROUTE_VERIFY_OTP,
				element: <VerifyOtp />,
			},
			{
				path: ROUTE_CREATE_PASSWORD,
				element: <CreatePassword />,
			},
			{
				path: ROUTE_DISCLOSURE_START,
				element: <DisclosureStart />,
			},
			{
				path: ROUTE_OTP_LOCKOUT,
				element: <Lockout />,
			},
			{
				path: ROUTE_DISCLOSURE_ACKNOWLEDGEMENT,
				element: <DisclosureAcknowledgement />,
			},
			{
				path: ROUTE_DISCLOSURE_ACCEPTANCE_SUCCESS,
				element: <DisclosureAcceptanceSuccess />,
			},
			{
				path: ROUTE_ERROR,
				element: <EnrollmentError />,
			},
		],
	},
	{
		path: ROUTE_FORGOT_PASSWORD,
		element: <EnrollmentLayout />,
		children: [
			{
				path: '',
				element: <ForgotPassword />,
			},
			{
				path: ROUTE_ERROR,
				element: <EnrollmentError />,
			},
		],
	},
	{
		path: ROUTE_ROOT,
		ErrorBoundary: RootErrorBoundary,
		element: (
			<AuthProvider>
				<ProtectedRoute>
					<Layout />
				</ProtectedRoute>
			</AuthProvider>
		),
		children: [
			{
				path: '',
				element: <Summary />,
			},
			{
				path: ROUTE_CONTRACTS,
				element: <Contracts />,
			},
			{
				path: ROUTE_INVOICES,
				element: (
					<ProtectedRoute restrictIfInvoicesBlocked>
						<Invoices />
					</ProtectedRoute>
				),
			},
		],
	},
	{
		path: ROUTE_USER_MANAGEMENT,
		element: (
			<AuthProvider>
				<ProtectedRoute allowedRoleScope="CIRCADIA_USER_MANAGE_ACCESS">
					<Layout />
				</ProtectedRoute>
			</AuthProvider>
		),

		children: [
			{
				path: ROUTE_EMPTY,
				element: <UserManagement />,
			},
			{
				path: ROUTE_ADD_USER,
				element: (
					<ProtectedRoute allowedRoleScope="CIRCADIA_USER_CREATE_ACCESS">
						<AddUser />
					</ProtectedRoute>
				),
			},
			{
				path: ROUTE_EDIT_USER,
				element: (
					<ProtectedRoute allowedRoleScope="CIRCADIA_USER_EDIT_ACCESS">
						<EditUser />
					</ProtectedRoute>
				),
			},
			{
				path: ROUTE_CONFIRM_USER,
				element: <ConfirmUser />,
			},
		],
	},
]);
